export const isCurrentSystemThemeDark = (): boolean => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }
    if (document.getElementsByTagName("html")[0].classList.contains("dark")) {
        return true;
    }
    if (document.getElementsByTagName("html")[0].classList.contains("light")) {
        return false;
    }
    try {
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    } catch {
        return false;
    }
};
